import React from "react";
import NewCommonServiceContent from "../../../common/NewCommonServices/NewCommonServiceContent";
import img from "../../../../assets/images/serviceImages/payPerClickWork.webp";

const PayPerClickWork = () => {
  return (
    <div>
      <NewCommonServiceContent>
        <div>
          <img
            src={img}
            alt=""
            className="w-full rounded-[16px] object-cover"
          />
        </div>
      </NewCommonServiceContent>
    </div>
  );
};

export default PayPerClickWork;
